const useAccessoryItem = (props) => {
  const {
    product 
  } = props;
  const {
    media_gallery 
  } = product;

  const images = [];

  media_gallery.forEach((temp) => {
    images.push(temp.url);
  });

  return {
    images,
    price: product.price_range.minimum_price.final_price,
    name: product.name,
    urlKey: product.url_key
  };
};

export default useAccessoryItem;
